/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPlanProgressCommand } from '../../models/add-plan-progress-command';
import { AddPlanProgressCommandResult } from '../../models/add-plan-progress-command-result';

export interface ApiPlanAddPlanProgressPatch$Params {
  
    /**
     * Plan Progress update command
     */
    body?: AddPlanProgressCommand
}

export function apiPlanAddPlanProgressPatch(http: HttpClient, rootUrl: string, params?: ApiPlanAddPlanProgressPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AddPlanProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanAddPlanProgressPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddPlanProgressCommandResult>;
    })
  );
}

apiPlanAddPlanProgressPatch.PATH = '/api/Plan/AddPlanProgress';
